(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

require('./vendors/h5bp');

/* 
 * Ejectuo las funciones de materialize
 *
 * - Ejecucion en: $(document).ready()
 */
function goMaterialize() {
  $(".button-collapse").sideNav();
  $('.materialboxed').materialbox();
  $('.slider').slider({
    height: 500,
    interval: 10000
  });
  $('select').material_select();
  $('.dropdown-button').dropdown({
    inDuration: 300,
    outDuration: 225,
    constrainWidth: false, // Does not change width of dropdown to that of the activator
    hover: true, // Activate on hover
    gutter: 0, // Spacing from edge
    belowOrigin: true, // Displays dropdown below the button
    alignment: 'left' // Displays dropdown with edge aligned to the left of button
  });
  $('.parallax').parallax();
  $('.goto').scrollSpy();
  // $('.tooltipped').tooltip({delay: 50});
}

/* 
 * Ejecuto funciones de slick slider
 *
 * - Ejecucion en: $(document).ready()
 */
function goSliders() {

  $('.img-slider').slick({
    autoplay: true,
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    }]
  });

  $('.text-slider').slick({
    autoplay: true,
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}

/* 
 * Mapa de CONTACTO  mediante la API de Google Maps
 */
function contactMap() {

  // Ubicación LAT
  var lugar = new google.maps.LatLng(-31.417634, -64.192283);
  var centro = new google.maps.LatLng(-31.424607, -64.192652);

  // Estilos
  var estilos = [{ "featureType": "landscape", "stylers": [{ "color": "#cccccc" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#8e3f64" }] }, { "featureType": "water", "stylers": [{ "color": "#d9cde3" }] }];

  // Opciones del mapa
  var mapOptions = {
    center: centro,
    zoom: 15,
    styles: estilos,
    scrollwheel: false
  };

  // Crear mapa
  var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

  // Marcador
  var marker = new google.maps.Marker({
    position: lugar,
    icon: "../assets/media/location-pin.png",
    map: map, //lo asocio al mapa
    optimized: false,
    title: 'Dr. Juan Tommasino'
  });

  var infoWindow = new google.maps.InfoWindow({
    content: "<p style='text-align:center; color:#303030;'>Duarte Quirós 515 <br>- 6to piso 'B' <br> (Esquina Bolivar;Frente a tribunales y plaza de la Intendencia) <br> Córdoba / Argentina</p>"
  });

  google.maps.event.addListener(marker, 'click', function () {
    infoWindow.open(map, marker);
  });
}

/* 
 * Alturas de elementos que nos e peuden manejar ocn CSS
 */
function okHeight() {
  $("#map-canvas").css("height", $(".contact-wrapper").height() + 200);

  $('.procedure').matchHeight();
}

/* 
 * Probamos nuestro amigo el timelifty
 *
 * - Ejecucion en: $(document).ready()
 */
function goTimelify() {
  $('.timeline').timelify({
    animLeft: "fadeInLeft",
    animCenter: "fadeInUp",
    animRight: "fadeInRight",
    animSpeed: 600,
    offset: 150
  });
}

/* 
 * Ejecuto las llamadas a fancybox
 *
 * - Ejecucion en: $(document).ready()
 */
function goFancy() {

  $('[data-fancybox="fancyimgs"]').fancybox({
    arrows: true,
    thumbs: {
      showOnStart: true
    }
  });
}

/* 
* Instanciamos las funciones :D
*
*/
$(document).ready(function () {
  "use strict";

  goMaterialize();
  goSliders();
  contactMap();
  okHeight();
  goFancy();
  goTimelify();
});

$(window).resize(function () {
  "use strict";

  okHeight();
});

},{"./vendors/h5bp":2}],2:[function(require,module,exports){
'use strict';

// Avoid `console` errors in browsers that lack a console.
(function () {
  'use strict';

  var method;
  var noop = function noop() {};
  var methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'];
  var length = methods.length;
  var console = window.console = window.console || {};

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
})();

},{}]},{},[1])

